import * as f from "react";
import { i as x, E as v, x as c, a as h, r as m, c as y } from "../createReactComponent-58f9bea8.mjs";
import { n as i } from "../property-9daa16cd.mjs";
import { e as b } from "../class-map-2994e95e.mjs";
import { b as w, r as A } from "../radio-8b0e9514.mjs";
import { r as R } from "../tooltip-cb602d1f.mjs";
import { r as C } from "../icon-button-a9d2a2d1.mjs";
import "../state-7560d4dc.mjs";
import "../icon-c572aa57.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
const k = x`
  :host {
    display: block;
  }

  :host .radio-group {
    border: none;
    margin: var(--exo-spacing-none);
    padding: var(--exo-spacing-none);
  }

  :host .radio-group--has-fieldset .radio--group-default {
    display: flex;
    align-items: center;
    margin-bottom: var(--exo-spacing-x-small);
    gap: var(--exo-spacing-2x-small);
    font: var(--exo-text-label-standard);
    font-size: var(--exo-font-size-x-small);
  }

  :host .radio--group-parent {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-2x-small);
    margin-bottom: var(--exo-spacing-x-small);
    font: var(--exo-text-label-standard-semi-bold);
    line-height: calc(1.2 * var(--exo-line-height-heading));
  }

  :host .info-text {
    font-size: var(--exo-font-size-x-small);
    color: var(--exo-color-font-secondary);
  }

  :host .radio-group:not(.radio-group--has-fieldset) .radio--group-default {
    position: absolute;
    width: var(--exo-spacing-none);
    height: var(--exo-spacing-none);
    clip: rect(
      var(--exo-spacing-none) var(--exo-spacing-none) var(--exo-spacing-none)
        var(--exo-spacing-none)
    );
    clip-path: inset(var(--exo-radius-circle));
    overflow: hidden;
    white-space: nowrap;
  }

  :host .radio-group__slot-vertical {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--exo-spacing-2x-small);
  }

  :host .radio-group__slot-horizontal {
    display: flex;
    flex-direction: row;
    gap: var(--exo-spacing-standard);
  }

  ::slotted(ex-radio) {
    align-self: flex-start;
  }
`;
var I = Object.defineProperty, E = Object.getOwnPropertyDescriptor, n = (o, t, e, l) => {
  for (var a, s = l > 1 ? void 0 : l ? E(t, e) : t, d = o.length - 1; d >= 0; d--)
    (a = o[d]) && (s = (l ? a(t, e, s) : a(s)) || s);
  return l && s && I(t, e, s), s;
};
const p = { ArrowUp: "ArrowUp", ArrowDown: "ArrowDown", ArrowLeft: "ArrowLeft", ArrowRight: "ArrowRight", Space: "Space" };
var T = ((o) => (o.VERTICAL = "vertical", o.HORIZONTAL = "horizontal", o))(T || {}), O = ((o) => (o.DEFAULT = "default", o.PARENT = "parent", o))(O || {});
const $ = [p.ArrowUp, p.ArrowLeft], S = Object.values(p), r = class u extends v {
  constructor() {
    super(...arguments), this.value = "", this.name = "option", this.fieldset = !1, this.alignment = "vertical", this.headerType = "default", this.infoText = "", this.required = !1, this.showInfoIcon = !1, this.hasMixedContent = !1;
  }
  getAllRadios() {
    return Array.from(this.querySelectorAll("ex-radio"));
  }
  connectedCallback() {
    super.connectedCallback(), this.updateCheckedRadio();
  }
  updateCheckedRadio() {
    this.getAllRadios().forEach((t) => {
      t.checked = t.value === this.value;
    });
  }
  dispatchOnChangeEvent() {
    this.dispatchCustomEvent("on-change", { value: this.value });
  }
  handleRadioClick(t) {
    const e = t.target;
    if ((!this.hasMixedContent || e instanceof w) && e.value) {
      const l = this.value;
      this.value = e.value, this.updateCheckedRadio(), this.value !== l && this.dispatchOnChangeEvent();
    }
  }
  static findIncrement(t) {
    return t.code === p.Space ? 0 : $.includes(t.code) ? -1 : 1;
  }
  handleKeyDown(t) {
    if (!S.includes(t.code))
      return;
    const e = this.getAllRadios(), l = e.find((d) => d.checked) ?? e[0];
    let a = e.indexOf(l) + u.findIncrement(t);
    a < 0 ? a = e.length - 1 : a > e.length - 1 && (a = 0), this.getAllRadios().forEach((d) => {
      d.checked = !1, d.tabIndex = -1;
    });
    const s = this.value;
    this.value = e[a].value, e[a].checked = !0, e[a].tabIndex = 0, typeof e[a].focus == "function" && e[a].focus(), this.value !== s && this.dispatchOnChangeEvent(), t.preventDefault();
  }
  handleSlotChange() {
    const t = this.getAllRadios();
    t.forEach((e) => {
      e.value === this.value ? e.checked = !0 : (e.checked = !1, e.tabIndex = -1);
    }), t.some((e) => e.checked) || (t[0].tabIndex = 0);
  }
  renderInfoText() {
    return this.showInfoIcon ? c`<ex-tooltip>
        <div>${this.infoText}</div>
        <span slot="anchor">
          <ex-icon-button
            icon="information"
            flavor="branded"
            type="tertiary"
            size="x-small"
            circular="true"
          ></ex-icon-button>
        </span>
      </ex-tooltip> ` : h;
  }
  renderRequired() {
    return this.required ? c`<span class="info-text">(required)</span>` : h;
  }
  update(t) {
    super.update(t), t.has("value") && t.get("value") !== this.value && this.hasUpdated && this.updateCheckedRadio();
  }
  render() {
    return c`
      <fieldset
        role="radiogroup"
        class=${b({ "radio-group": !0, "radio-group--has-fieldset": this.fieldset })}
      >
        <legend class="radio--group-${this.headerType}">
          <slot name="label">${this.label}</slot>
          ${this.renderInfoText()}${this.renderRequired()}
        </legend>
        <slot
          class="radio-group__slot-${this.alignment}"
          @click=${this.handleRadioClick}
          @keydown=${this.handleKeyDown}
          @slotchange=${this.handleSlotChange}
        >
        </slot>
      </fieldset>
    `;
  }
};
r.styles = k, n([i()], r.prototype, "label", 2), n([i({ reflect: !0 })], r.prototype, "value", 2), n([i()], r.prototype, "name", 2), n([i({ type: Boolean, attribute: "fieldset", reflect: !0 })], r.prototype, "fieldset", 2), n([i({ type: String })], r.prototype, "alignment", 2), n([i({ type: String })], r.prototype, "headerType", 2), n([i()], r.prototype, "infoText", 2), n([i({ type: Boolean, reflect: !0 })], r.prototype, "required", 2), n([i({ type: Boolean, reflect: !0 })], r.prototype, "showInfoIcon", 2), n([i({ type: Boolean, attribute: "has-mixed-content" })], r.prototype, "hasMixedContent", 2);
let g = r;
const q = (o = "") => {
  m("ex-radio-group", g, o), A(o), R(o), C(o);
}, P = y({ tagName: "ex-radio-group", elementClass: g, react: f, events: { onChange: "on-change" }, displayName: "ExRadioGroup", registerWebComponent: q });
export {
  P as ExRadioGroup,
  T as RadioGroupAlignment,
  O as RadioHeaderType,
  q as register
};
